import { LoadingSpinner } from "@/core/components/loading-spinner";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";

export const PayBreakdownCalculationLoadingState = () => (
  <Stack
    align="center"
    justify="center"
    gap="md"
    fullWidth
    className="min-h-[300px] px-6 py-16 text-center"
  >
    <LoadingSpinner size="lg" color="primary" containerClassName="h-auto" />
    <Stack align="center" gap="xs">
      <Typography variant="titleW3">We're crunching the numbers.</Typography>
      <Typography variant="bodyW2" textColor="secondary">
        Payroll calculation can take a few minutes. This page updates
        automatically when the results are ready.
      </Typography>
    </Stack>
  </Stack>
);
